let componentId = 0

export default app => {
  app.mixin({
    data() {
      return {
        componentId: (componentId++).toString()
      }
    }
  })
}
